"use client";
import { Badge } from "@/components";
import { CitizensRotate } from "@/components/citizens-rotate";
import { cn } from "@/lib/utils";
import { useCidadao } from "@/providers/cidadao-provider";
import Link from "next/link";
import { LikesCounter } from "./likes-counter";
import { UserName } from "./user-name";

export function Banner() {
  const { cidadao, likes } = useCidadao();
  const isLoggedIn = !!cidadao;
  const name = cidadao?.nome ?? "Visitante";

  return (
    <>
      <div className="relative flex flex-col justify-center items-center bg-white xl:bg-[#E5684A] xl:bg-[url(/pattern-primary.svg)] xl:-mt-22 xl:rounded-b-2xl xl:h-[350px]">
        <div className="flex flex-col justify-end items-start gap-1 mx-auto px-4 h-5/8 container">
          <h1 className={cn("hidden xl:block", isLoggedIn ? "mb-12" : "mb-19")}>
            <Link href="/votacao"><Badge>Painel de Votação</Badge></Link>
          </h1>
          {isLoggedIn && <UserName name={name} />}
        </div>

        <CitizensRotate className="hidden xl:block right-20 bottom-0 z-20 absolute mx-auto w-1/3 2xl:w-1/4 h-[350px] object-[top] object-cover -translate-x-1/4 2xl:-translate-x-1/2" />
      </div>

      {isLoggedIn && (
        <div className="block top-0 z-10 sticky bg-white xl:bg-[#E5684A] xl:bg-[url(/pattern-primary.svg)] xl:-mt-16 xl:pb-0 rounded-b-2xl">
          <div className="flex flex-col gap-1 mx-auto px-4 pt-1 xl:pt-2 pb-3 container">
            <LikesCounter likes={likes} />
          </div>
        </div>
      )}
    </>
  );
}
